import useAudioPlayerStore from '@/client/stores/useAudioPlayerStore';
import { Button } from '@/components/ui/button';
import { cn } from '@/utils';
import { ClassValue } from 'clsx';
import React from 'react';

interface Props {
  className?: ClassValue;
}

export function AudioPlayerStopButton({ className }: Props) {
  const { player } = useAudioPlayerStore();

  return (
    <Button className={cn('cursor-pointer', className)} onClick={player.stop.bind(player)} aria-label="Stop">
      Stop
    </Button>
  );
}
